module.exports = __webpack_public_path__ + "static/media/development-portaria.e8d1319c.png";